import { Component, Input, OnInit } from '@angular/core';
import { LastLearningCourseInterface, LastLearningCourseModel } from '../../../models/home.model';
import { LearningService } from '../../../../../core/services/api/learning.service';
import { ErrorService } from '../../../../../core/services/error.service';
import { UtilitiesService } from '../../../../../core/services/utilities.service';
import { ProgramType } from '../../../../../core/enum/webinar-course.enum';

@Component({
    selector: 'app-progress-indicator',
    templateUrl: './progress-indicator.component.html',
})
export class ProgressIndicatorComponent implements OnInit {
    @Input() isFirstTimeJourney = false;

    dummyLastLearningCourse: LastLearningCourseInterface = {
        programId: '',
        programTitle: 'Introduction to E-Invoice',
        progress: 85,
        lastProgramChapter: 'Understanding E-Invoice',
        lastProgramChapterId: '',
        remainingSeconds: 1200,
        programType: ProgramType.Course,
    };

    protected hideProgressBar = true;
    protected details: LastLearningCourseModel = new LastLearningCourseModel({} as LastLearningCourseInterface);

    constructor(
        private utilitiesService: UtilitiesService,
        private errorService: ErrorService,
        private learningService: LearningService,
    ) { }

    ngOnInit(): void {
        if (!this.isFirstTimeJourney) {
            this.getLastDroppedProgress();
        } else {
            this.details = new LastLearningCourseModel(this.dummyLastLearningCourse);
            this.hideProgressBar = false;
        }
    }

    private getLastDroppedProgress(): void {
        this.learningService.getLastCorseDetails().subscribe({
            next: (resp) => {
                if (!resp || !resp.result) {
                    return;
                }

                this.details = new LastLearningCourseModel(resp.result);

                if (this.details && this.details.progress !== 100) {
                    this.hideProgressBar = false;
                }
            },
            error: (error) => {
                this.errorService.showError(error);
            },
        });
    }

    public getRemainingTime(seconds: number): String {
        
        return this.utilitiesService.getRemainingTimeString(Math.ceil(seconds/60)).toLowerCase();
    }
}
